import { useEffect } from "react";

// En el celular las tablas se ven como tarjetas (estilos .tabla-tarjetas en responsive.css).
// Este componente le pone a cada celda el título de su columna (data-label) y marca la
// tabla, para no tener que hacerlo a mano en cada pantalla. No dibuja nada.
//
// Quedan fuera las tablas con 3 columnas o menos (ya caben), las que tienen la clase
// sin-tarjetas y las que ya vienen marcadas a mano con tabla-tarjetas.
const MINIMO_COLUMNAS = 4;

function titulosDeColumnas(tabla) {
  const fila = tabla.querySelector("thead tr:last-child");
  if (!fila) return null;
  const titulos = [];
  [...fila.children].forEach((th) => {
    const texto = th.textContent.replace(/[↕↑↓▲▼]/g, "").replace(/\s+/g, " ").trim();
    for (let i = 0; i < (th.colSpan || 1); i++) titulos.push(texto);
  });
  return titulos;
}

function etiquetar(tabla) {
  if (tabla.classList.contains("sin-tarjetas") || tabla.dataset.tarjetasManual === "1") return;
  if (tabla.classList.contains("tabla-tarjetas") && !tabla.dataset.tarjetasAuto) {
    tabla.dataset.tarjetasManual = "1";
    return;
  }
  const titulos = titulosDeColumnas(tabla);
  if (!titulos || titulos.length < MINIMO_COLUMNAS) return;
  tabla.classList.add("tabla-tarjetas");
  tabla.dataset.tarjetasAuto = "1";

  // El título de la tarjeta es la primera columna con nombre que no sea "#".
  const indiceTitulo = titulos.findIndex((t) => t && t !== "#");

  tabla.querySelectorAll(":scope > tbody > tr").forEach((tr) => {
    let columna = 0;
    [...tr.children].forEach((td) => {
      const span = td.colSpan || 1;
      if (span === 1) {
        const titulo = titulos[columna] || "";
        if (columna === indiceTitulo) td.classList.add("celda-titulo");
        else if (!titulo) td.classList.add("celda-accion");
        else if (td.dataset.label === undefined) td.dataset.label = titulo;
      }
      columna += span;
    });
  });
}

function TablasCelular({ contenedorSelector = ".app-main" }) {
  useEffect(() => {
    const contenedor = document.querySelector(contenedorSelector);
    if (!contenedor) return undefined;
    let pendiente = null;
    const revisar = () => {
      pendiente = null;
      contenedor.querySelectorAll("table").forEach(etiquetar);
    };
    revisar();
    // Las pantallas cargan datos después de abrirse: se revisa de nuevo cuando cambia
    // el contenido (solo nodos agregados o quitados, no atributos, para no repetir sin fin).
    const observador = new MutationObserver(() => {
      if (!pendiente) pendiente = requestAnimationFrame(revisar);
    });
    observador.observe(contenedor, { childList: true, subtree: true });
    return () => {
      observador.disconnect();
      if (pendiente) cancelAnimationFrame(pendiente);
    };
  }, [contenedorSelector]);
  return null;
}

export default TablasCelular;
